import { action } from "mobx";
import { useControllers } from "../base/hooks/useRootController.hook";
import { TopLevelModuleName } from "../constants/topLevelModuleName.enum";

export const useRegisterTopLevelModule = action((name: TopLevelModuleName) => {
  const { COMMON } = useControllers();
  COMMON.topLevelModuleName = name;
})